import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoadingController, LoadingOptions } from '@ionic/angular';

@Injectable()
export class LoaderProvider {
  private pool: LoaderPrivate[] = [];
  private active: HTMLIonLoadingElement | null = null;
  private idCounter: number = 0;
  private timerId: any = null;

  constructor(private http: HttpClient, private loadingCtrl: LoadingController) {}

  /** Dismiss all loaders immediately */
  async dismissAll() {
    this.pool = [];
    if (this.active) {
      await this.active.dismiss().catch(() => {});
      this.active = null;
    }
    if (this.timerId) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
  }

  /** Create a loader */
  create(opts?: LoadingOptions|any): LoadingPopup {
    this.idCounter++;
    this.pool.push({ id: this.idCounter, text: opts?.message || '' });
    this.presentLatest();
    return new LoadingPopup(this, this.idCounter);
  }

  public async presentLatest() {
    if (!this.pool.length) return;

    const latest = this.pool[this.pool.length - 1];
    if (this.active) {
      await this.active.dismiss().catch(() => {});
      this.dismissAll()
      this.active = null;
    }

    this.active = await this.loadingCtrl.create({
      message: latest.text,
      backdropDismiss: false,
      spinner: 'crescent',
    });

    await this.active.present();
  }

  /** Remove loader by id */
  async removeId(id: number, resolve: Function) {
    this.pool = this.pool.filter(x => x.id !== id);

    if (this.pool.length) {
      // Show the latest remaining loader
      await this.presentLatest();
      resolve();
    } else {
      // No loaders left, dismiss active
      if (this.active) {
        this.timerId = setTimeout(async () => {
          await this.active?.dismiss().catch(() => {});
          this.active = null;
          this.timerId = null;
          resolve();
        }, 100); // small delay to prevent flicker
      } else {
        resolve();
      }
    }
  }
}

interface LoaderPrivate {
  id: number;
  text: string;
}

export class LoadingPopup {
  constructor(private prov: LoaderProvider, public id: number) {}

  dismiss(): Promise<void> {
    return new Promise((resolve) => {
      if (this.prov) {
        this.prov.removeId(this.id, resolve);
        this.prov = null;
      } else {
        resolve();
      }
    });
  }

  present(): Promise<void> {
    return new Promise((resolve) => {
      if (this.prov) {
        this.prov.presentLatest();
      }
      resolve();
    });
  }
}

